import { useState, Fragment } from 'react';
import {
  DataGrid,
  Column,
  Editing,
  Lookup,
  HeaderFilter,
  Search,
} from 'devextreme-react/data-grid';
import notify from 'devextreme/ui/notify';
import { ExternalMailSystem } from '~/components/external-mail-system/external-mail-system';
import { EmailClient } from '~/components/email-client/email-client';
import { appConst } from '~/app-const';
import {
  CreateAuthorizedDataSource, CreateAuthorizedStore, getAuthorizationTokenAsync
} from '~/helpers/data';

export function CommitteeDistributionList(props) {
  const [viewEmailClient, setViewEmailClient] = useState(false);
  const [emailFormData, setEmailFormData] = useState();

  const emailAddressTypesData = CreateAuthorizedDataSource(
    { loadUrl: `${window.env.apiEndpoint}/api/v1/Members/EmailAddressTypesLookup` },
    null,
    'Value', false,
  );

  const committeeDistributionListData = CreateAuthorizedDataSource(
    {
      loadUrl: `${window.env.apiEndpoint}/api/v1/CommitteeMemberships/GetCommitteeDistributionLists`,
      insertUrl: `${window.env.apiEndpoint}/api/v1/CommitteeMemberships/PostCommitteeDistributionList`,
      updateUrl: `${window.env.apiEndpoint}/api/v1/CommitteeMemberships/PutCommitteeDistributionList`,
      deleteUrl: `${window.env.apiEndpoint}/api/v1/CommitteeMemberships/DeleteCommitteeDistributionList`,
    },
    {
      load: { committeeId: props.committeeId },
      insert: { committeeId: props.committeeId },
      update: { committeeId: props.committeeId },
    },
    'Id', false,
  );

  return (
    <Fragment>
      <DataGrid
        dataSource={committeeDistributionListData}
        key="Id"
        {...appConst.defaultGridOptions}
        onRowUpdating={
          (e) => {
            e.newData = { ...e.oldData, ...e.newData };
          }
        }
        height="100%"
      >
        <HeaderFilter
          visible
        >
          <Search enabled={true}/>
        </HeaderFilter>
        <Editing
          mode="row"
          allowAdding
          allowDeleting
          allowUpdating
        />
        <Column
          dataField="SchoolYearId"
          dataType="number"
          caption="School Year"
        >
          <Lookup
            dataSource={props.schoolYearsData}
            valueExpr="Value"
            displayExpr="Text"
          />
        </Column>
        <Column
          dataField="EmailAddressTypeId"
          dataType="number"
          caption="Email Address Type"
        >
          <Lookup
            dataSource={emailAddressTypesData.store()}
            valueExpr="Value"
            displayExpr="Text"
          />
        </Column>
        <Column
          dataField="Name"
          dataType="text"
          caption="Name"
          allowEditing={false} />
        <Column
          dataField="StatusMessage"
          allowEditing={false}
          cellRender={
            (data) => {
              const row = data.data;
              return <ExternalMailSystem statusMessage={row.StatusMessage} hasError={row.HasError} entityId={row.Id} entityType="CommitteeDistributionList" />
            }
          }
        />
        <Column
          type="buttons"
          width={110}
          buttons={[
            {
              name: "delete",
              hint: "Delete Committee Distribution List",
              icon: 'trash',
            },
            {
              name: "edit",
              hint:"Edit Committee Distribution List",
              icon: 'edit',
            },
            {
              name: "email",
              hint: "Send Email to Distribution List",
              icon: 'email',
              visible: (e) => {
                return !e.row.isEditing;
              },
              onClick: async (e) => {
                const token = await getAuthorizationTokenAsync();

                const defaultFromEmailDS = CreateAuthorizedStore({ loadUrl: `${window.env.apiEndpoint}/api/v1/DistributionList/GetDefaultFromEmail` }, null, 'Value');
                defaultFromEmailDS.load().then(
                  (data) => {
                    setViewEmailClient(true);
                    setEmailFormData({ email: token.account.username, name: data[0].fromName, to: e.row.data.Name });
                  },
                  (error) => {
                    notify({ message: error.message, shading: true }, 'error');
                  }
                );
              }
            },
          ]}
        />
      </DataGrid>
      <EmailClient visible={viewEmailClient} formData={emailFormData} setViewEmailClient={setViewEmailClient} />
    </Fragment>
  );
}